const colors = {
  background: {
    default: "#f0f2f5"
  },

  text: {
    main: "#7b809a",
    focus: "#7b809a"
  },

  transparent: {
    main: "rgba(0, 0, 0, 0)"
  },

  white: {
    main: "#ffffff",
    focus: "#ffffff"
  },

  black: {
    light: "#000000",
    main: "#000000",
    focus: "#000000"
  },

  primary: {
    main: "#00ccbc",
    focus: "#00ccbc"
  },

  secondary: {
    main: "#1A7E89",
    focus: "#1A7E89"
  },

  info: {
    main: "rgb(255,174,88)",
    focus: "rgb(255,174,88)"
  },

  success: {
    main: "#CC008A",
    focus: "#CC008A"
  },

  warning: {
    main: "#FEE440",
    focus: "#FEE440"
  },

  error: {
    main: "#d41f1a",
    focus: "#EF5350"
  },

  light: {
    main: "#f0f2f5",
    focus: "#f0f2f5"
  },

  dark: {
    main: "#344767",
    focus: "#2c3c58"
  },

  grey: {
    100: "#f8f9fa",
    200: "#f0f2f5",
    300: "#dee2e6",
    400: "#ced4da",
    500: "#adb5bd",
    600: "#6c757d",
    700: "#495057",
    800: "#343a40",
    900: "#212529"
  },

  gradients: {
    primary: {
      main: "#00ccbc",
      state: "#00ccbc"
    },

    secondary: {
      main: "#1A7E89",
      state: "#1A7E89"
    },

    info: {
      main: "rgb(255,174,88)",
      state: "rgb(255,174,88)"
    },
    tifanny: {
      main: "#6DE2D4",
      focus: "#6DE2D4"
    },

    success: {
      main: "#CC008A",
      state: "#CC008A"
    },

    warning: {
      main: "#FEE440",
      state: "#fae97d"
    },

    error: {
      main: "#d41f1a",
      state: "#E53935"
    },

    light: {
      main: "#EBEFF4",
      state: "#CED4DA"
    },

    dark: {
      main: "#42424a",
      state: "#191919"
    }
  },

  socialMediaColors: {
    facebook: {
      main: "#3b5998",
      dark: "#344e86"
    },

    twitter: {
      main: "#55acee",
      dark: "#3ea1ec"
    },

    instagram: {
      main: "#125688",
      dark: "#0e456d"
    },

    linkedin: {
      main: "#0077b5",
      dark: "#00669c"
    },

    pinterest: {
      main: "#cc2127",
      dark: "#b21d22"
    },

    youtube: {
      main: "#e52d27",
      dark: "#d41f1a"
    },

    vimeo: {
      main: "#1ab7ea",
      dark: "#13a3d2"
    },

    slack: {
      main: "#3aaf85",
      dark: "#329874"
    },

    dribbble: {
      main: "#E0479E",
      dark: "#E0479E"
    },

    github: {
      main: "#24292e",
      dark: "#171a1d"
    },

    reddit: {
      main: "#ff4500",
      dark: "#e03d00"
    },

    tumblr: {
      main: "#35465c",
      dark: "#2a3749"
    }
  },

  badgeColors: {
    primary: {
      background: "#f8b3ca",
      text: "#cc084b"
    },

    secondary: {
      background: "#d7d9e1",
      text: "#6c757d"
    },

    info: {
      background: "#aecef7",
      text: "#095bc6"
    },

    success: {
      background: "#bce2be",
      text: "#339537"
    },

    warning: {
      background: "#ffd59f",
      text: "#c87000"
    },

    error: {
      background: "#f61200",
      text: "#f61200"
    },

    light: {
      background: "#ffffff",
      text: "#c7d3de"
    },

    dark: {
      background: "#8097bf",
      text: "#1e2e4a"
    }
  },

  coloredShadows: {
    primary: "#E0479E",
    secondary: "#110e0e",
    info: "#00bbd4",
    success: "#4caf4f",
    warning: "#ff9900",
    error: "#f44336",
    light: "#adb5bd",
    dark: "#404040",
    tifanny: "#6DE2D4"
  },

  inputBorderColor: "#d2d6da",

  tabs: {
    indicator: { boxShadow: "#ddd" }
  }
};

export default colors;
